import React from 'react';
import { IAccordionPanelProps } from './AccordionPanel';

interface IAccordionPanelContext {
  isOpen?: IAccordionPanelProps['isOpen'];
  panelId?: IAccordionPanelProps['panelId'];
  /** The function used to manage the openPanelIdsArr */
  handleSetCurrentOpenPanelsIdsArr?(managedPanelId: string): void;
}

/**
 * Context below is used for connecting Accordion component to AccordionPanels,
 * provides them openPanelIdsArr array that contains panelsIds of open panels.
 */
const AccordionPanelContext = React.createContext<IAccordionPanelContext>({});

export default AccordionPanelContext;
